import { useEffect, useMemo, useState } from 'react'
import { formatearFecha } from '../../helpers/helper'
import { adjuntoBuilder } from '../../reutilizables/upload/adjuntoBuilder'
import * as archivoAdjuntoService from '../../servicios/archivoAdjuntoService'
import { Responder } from './Responder'
import styles from './respuesta.module.css'

export const Respuesta = ({
  respuesta,
  usuario,
  mensaje,
  texto,
  errores,
  handleChange,
  submitRespuesta,
  valido,
  idPublicacion,
  adjuntoPendiente,
  setAdjuntoPendiente,
  manejarAdjunto
}) => {
  const respuestas = Array.isArray(respuesta) ? respuesta : respuesta.respuestas || []

  const [adjunto, setAdjunto] = useState([])

  const fetchAdjunto = async (idAdjunto, idMensaje) => {
    const { data } = await archivoAdjuntoService.buscarAdjuntosPorId(idAdjunto)
    const { dataAdjunto, adjunto } = data
    const previewAdjunto = await adjuntoBuilder(dataAdjunto, adjunto, adjunto.archivo, {
      preview: true
    })
    setAdjunto((prev) => ({
      ...prev,
      [idMensaje]: { ...previewAdjunto, idAdjunto: adjunto.idAdjunto }
    }))
  }

  const adjuntos = respuestas.map((resp) => {
    return { idAdjunto: resp.IdsAdjuntosList, idMensaje: resp.idMensaje }
  })

  const adjuntosIds = useMemo(
    () => adjuntos?.map((a) => a.idAdjunto).join(','),
    [adjuntos]
  )

  useEffect(() => {
    if (!adjuntos?.length) {
      return
    }

    adjuntos.forEach(({ idAdjunto, idMensaje }) => {
      if (idAdjunto && !adjunto?.[idAdjunto]) {
        fetchAdjunto(idAdjunto, idMensaje)
      }
    })
  }, [adjuntosIds])

  return respuestas.map((resp) => (
    <div key={resp.idMensaje} className="ms-4 text-secondary position-relative mb-2">
      <div className="respuestaFlecha"></div>

      <p className={styles.textoRespuesta}>
        {resp.texto}
        <br />
        {adjunto && adjunto[resp.idMensaje] && (
          <span>
            <img
              className={styles.imgAdjunto}
              src={adjunto[resp.idMensaje].url}
              alt={adjunto[resp.idMensaje].nombre}
            />
          </span>
        )}
        <small className="ml-2">{formatearFecha(resp.fechaEscrito, 'FH', 'hs')}</small>
      </p>

      {resp.respuestas && resp.respuestas.length > 0 && (
        <Respuesta
          respuesta={resp.respuestas}
          usuario={usuario}
          mensaje={mensaje}
          texto={texto}
          errores={errores}
          handleChange={handleChange}
          submitRespuesta={submitRespuesta}
          valido={valido}
          idPublicacion={idPublicacion}
          adjuntoPendiente={adjuntoPendiente}
          setAdjuntoPendiente={setAdjuntoPendiente}
          manejarAdjunto={manejarAdjunto}
        />
      )}

      <Responder
        idComprador={mensaje.idComprador}
        idVendedor={mensaje.idVendedor}
        idUsuarioChat={resp.idUsuarioChat}
        idMensaje={resp.idMensaje}
        usuario={usuario}
        handleChange={handleChange}
        texto={texto}
        errores={errores}
        submitRespuesta={submitRespuesta}
        valido={valido}
        mensaje={mensaje}
        idPublicacion={idPublicacion}
        adjuntoPendiente={adjuntoPendiente}
        setAdjuntoPendiente={setAdjuntoPendiente}
        manejarAdjunto={manejarAdjunto}
      />
    </div>
  ))
}
